module.exports = __webpack_public_path__ + "fonts/foco_black.4bc59d81.woff";